import React from 'react';
import { Drawer } from 'antd';
import type { WeatherAlert } from '../../services/weatherAlertService';
import { weatherEn } from '../../content/weather.en';
import styles from './WeatherAlertsDrawer.module.css';

export interface WeatherAlertsDrawerProps {
  open: boolean;
  alerts: WeatherAlert[];
  onClose: () => void;
}

const WeatherAlertsDrawer: React.FC<WeatherAlertsDrawerProps> = ({ open, alerts, onClose }) => {
  return (
    <Drawer
      title={weatherEn.alertsTitle}
      placement="bottom"
      height="auto"
      open={open}
      onClose={onClose}
      className={styles.drawer}
    >
      {alerts.length === 0 ? (
        <p className={styles.empty}>{weatherEn.noAlerts}</p>
      ) : (
        <ul className={styles.list}>
          {alerts.map((alert) => (
            <li
              key={`${alert.type}-${alert.severity}`}
              className={`${styles.item} ${alert.severity === 'severe' ? styles.severe : styles.moderate}`}
            >
              <div className={styles.itemTitle}>{alert.title}</div>
              <div className={styles.itemMessage}>{alert.message}</div>
            </li>
          ))}
        </ul>
      )}
    </Drawer>
  );
};

export default WeatherAlertsDrawer;
